import { AttachFile, Download, DownloadOutlined } from "@mui/icons-material";
import { Avatar, Button, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import axios from "axios";


export default function FilestorageViewer(props) {

    const downloadPdf = async (xDokument) => {
        try {
            axios.get('/api/data/filestorage/download', {
                responseType: 'blob',
                headers: {
                    objectid: props.files.id,
                    filename: xDokument
                }
            }).then((response) => {
                const contentType = response.headers['content-type'] || 'application/octet-stream';
                const blob = new Blob([response.data], { type: contentType });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = xDokument;
                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
            }, (error) => {
                console.error('Download failed:', error);
            });
        } catch (err) {
            console.error(err);
        }
    };

    if (!props.files && !props.files.beleg && !props.files.dokumente) {
        return (<div></div>)
    }

    return (
        <Grid container sapcing={2} direction={"column"}>
            <Grid item xs={12}>
                <Typography variant="h5">Dokumente</Typography>
            </Grid>
            <Grid item>
                <List>
                    {props.files.beleg.dokumente.map((xDokument) => {
                        return (<ListItem>
                            <ListItemAvatar>
                                <IconButton onClick={() => downloadPdf(xDokument)}><DownloadOutlined></DownloadOutlined></IconButton>
                            </ListItemAvatar>
                            <ListItemText primary={xDokument} secondary="" />
                        </ListItem>)
                    })

                    }
                </List>
                {/* <Button onClick={() => downloadPdf()}>{props.files.beleg.dokumente}</Button> */}
            </Grid>
        </Grid>
    )


}